import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import {} from 'react';
import Icon, { SurfaceIcon, TonalIcon } from '../Icon';
import { useTheme } from '@emotion/react';
const BaseIconButtonFactory = (Element) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const theme = useTheme();
    return (_jsx(Element, { ...props, css: [
            props['onClick'] !== undefined && {
                'cursor': 'pointer',
                ':hover': {
                    filter: 'brightness(1.2)',
                },
            },
            props.disabled && {
                opacity: theme.contentAlpha.disabled,
                color: props.disabledContentColor,
                backgroundColor: props.disabledContainerColor,
                cursor: 'not-allowed',
            },
        ] }));
};
const IconButton = BaseIconButtonFactory(Icon);
export const TonalIconButton = BaseIconButtonFactory(TonalIcon);
export const SurfaceIconButton = BaseIconButtonFactory(SurfaceIcon);
export default IconButton;
//# sourceMappingURL=IconButton.js.map